import React from 'react'
import DynamicHeadingTags from 'src/components/common/DynamicHeadingTags/DynamicHeadingTags'
import { HeadingLevel } from 'src/typings/headingTags'
import { useInsiderCampaignLoader } from 'src/hooks/useInsiderCampaignLoader'
import InsiderCartCampaignCard from './InsiderCartCampaignCard'
import '../shelf-minicart.scss'

interface Props {
  insiderShelfTitle: string
  headingTitle: HeadingLevel
  campaignId: number
  fontfamily: string
  itemsToDisplay: number
}

const InsiderCartShelfCampaign: React.FC<Props> = ({
  campaignId,
  insiderShelfTitle,
  headingTitle,
  fontfamily,
itemsToDisplay
}) => {
  const {
    isLoading,
    hasProducts,
    products: sessionProducts,
    variationId,
  } = useInsiderCampaignLoader(String(campaignId), 5000)

  if (isLoading || !hasProducts) return null

  const idsList = sessionProducts.map((p) => p.item_id).join(',')

  return (
    <section className="insider-shelf-minicart">
      <div className="shelf-header--minicart">
        <DynamicHeadingTags
          className="insider-shelf__title--minicart"
          as={headingTitle}
          style={{
            fontFamily: fontfamily === '2' ? 'roboto' : 'Cormorant Garamond',
          }}
        >
          {insiderShelfTitle}
        </DynamicHeadingTags>
      </div>
      <div className={`insider-wrapper-${variationId}`}>
        <div
          className="recommender-body"
          data-recommended-items={`[${idsList}]`}
        >
          {sessionProducts.slice(0, itemsToDisplay).map((product, idx) => (
            <div
              key={`${product?.item_id}-${idx}`}
              className="recommender-box-item"
            >
              <InsiderCartCampaignCard product={product} index={idx} />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default InsiderCartShelfCampaign
